module.exports = __webpack_public_path__ + "static/media/izlozba (1).723bfc7b.jpg";